import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const RENTAL_REPAIRS_MOULD_SOURCES_A = [
  {
    sourceId: "rental-repairs-source-process",
    topicId: "rental-repairs-mould",
    title: "Getting repairs done on a rental property",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/getting-repairs-done",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 urgent·non-urgent repair 구분, written request, 연락 시도, licensed tradesperson, current reimbursement limit·14-day repayment와 rent withholding 금지를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW private rental의 repair 요청·자비수리·환급 일반 절차",
    followUp: "repair 직전 urgent definition, current reimbursement cap, approved tradesperson와 lease contact를 재확인",
  },
  {
    sourceId: "rental-repairs-source-landlord",
    topicId: "rental-repairs-mould",
    title: "Landlord responsibilities for repair and maintenance of rental properties",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/landlord-obligations-and-responsibilities-for-rental-properties",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 fit-to-live, reasonable repair, health·safety, urgent·non-urgent repair와 tenant-caused damage 경계를 확인",
    reviewStatus: "live_verified",
    claimScope: "landlord의 repair·maintenance·security·health and safety 의무",
    followUp: "property age, rent, prospective life와 tenant-caused damage evidence를 개별 사안에서 확인",
  },
  {
    sourceId: "rental-repairs-source-minimum",
    topicId: "rental-repairs-mould",
    title: "Minimum standards for rental properties",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/minimum-standards-for-rental-properties",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 structural soundness, lighting, ventilation, utilities, plumbing, hot/cold water와 private bathroom의 seven minimum standards를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW rental property가 tenancy 동안 유지해야 하는 minimum standards",
    followUp: "property-specific unfitness, building defects와 current legislative standard를 행동 시점에 확인",
  },
  {
    sourceId: "rental-repairs-source-mould",
    topicId: "rental-repairs-mould",
    title: "Mould in a rental property",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/mould-a-rental-property",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 mould health risk, ventilation minimum standard, defect·leak·pre-existing mould와 tenant moisture responsibility, urgent repair 가능성을 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW rental mould의 landlord·tenant responsibility와 reporting",
    followUp: "leak·ventilation defect, onset date, health symptoms와 qualified assessment 필요성을 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of RENTAL_REPAIRS_MOULD_SOURCES_A) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
